import styled from "styled-components";
import { Button as AntButton } from "antd";

export const RootContainer = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;

  position: relative;
`;

export const SkipButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  box-sizing: border-box;

  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;

export const SkipButton = styled.div`
  padding: 12px 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.50);

  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`

    height: auto;
    width: 100% !important;
`;

export const Title = styled.div`
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 32px; /* 145.455% */

  width: 100%;

	@media screen and (max-width: 375px) {
		font-size: 18px;
	}
`;

export const Description = styled.div`
  color: var(--color-inverse, #2A2A2A);
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  span {
    font-weight: bold;
  }
  width: 55%;

  @media screen and (max-width: 420px) {
    width: 65%;
  }
  @media screen and (max-width: 350px) {
    width: 75%;
  }
  @media screen and (max-width: 310px) {
    width: 85%;
  }
`;

export const RuleTitleWrapper = styled.div`
	padding: 16px;
	margin: 0 auto 40px;
	box-sizing: border-box;
	width: calc(100% - 64px);

	border-radius: 20px;
	background: #FFF4D2;
`;

export const RuleTitle = styled.div`
	text-align: left;
	color: #2A2A2A;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`;

export const Rule = styled.div`
	margin: 0px;
	padding: 0px;
	color: #2A2A2A;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */

  ul{
    padding-inline-start: 20px !important;
  }
`;

export const ButtonWrapper = styled.div`
	width: calc(100% - 64px);
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  box-sizing: border-box;
`;

export const Button = styled(AntButton)`
  width: 100% !important;
  height: 48px !important;
  flex: 1;

  font-size: ${props => props.$isBurmese ? "12px" : "14px"};
  font-weight: 600;

  svg{
    width: 20px;
    height: 20px;
  }

  @media screen and (max-width: 350px) {
    font-size: 12px;
    height: 42px !important;
  }
`;

export const Line = styled.div`
  background: linear-gradient(to right, #FFD648 50%, #AA5E1B 100%);
  width: calc(100% - 60px);
  height: 1px;
  margin: 24px auto;
`

